<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
    <div class="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
      <div class="text-center mb-8">
        <h2 class="text-3xl font-bold text-gray-800 dark:text-white">Welcome aboard!</h2>
        <p class="text-gray-600 dark:text-gray-400 mt-3">
          For security reasons, please set a new password for your account.
        </p>
      </div>

      <form @submit.prevent="handleResetPassword" class="space-y-6">
        <div>
          <label class="block text-sm font-medium mb-2">New Password</label>
          <input
            v-model="newPassword"
            type="password"
            required
            minlength="8"
            class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#74bd54]"
            placeholder="Minimum 8 characters"
          />
        </div>

        <div>
          <label class="block text-sm font-medium mb-2">Confirm New Password</label>
          <input
            v-model="confirmPassword"
            type="password"
            required
            class="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#74bd54]"
            placeholder="Confirm your password"
          />
        </div>

        <button
          type="submit"
          :disabled="isLoading"
          class="w-full bg-[#74bd54] hover:bg-[#63a43f] text-white font-medium py-3.5 rounded-lg transition"
        >
          {{ isLoading ? 'Updating Password...' : 'Update Password & Continue' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/services/api';
import { useToast } from 'vue-toastification';

const router = useRouter();
const toast = useToast();

const newPassword = ref('');
const confirmPassword = ref('');
const isLoading = ref(false);

const handleResetPassword = async () => {
  if (newPassword.value.length < 8) {
    toast.error("Password must be at least 8 characters long");
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    toast.error("Passwords do not match");
    return;
  }

  isLoading.value = true;

  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    await api.put('Users.php', {
      id: user.id,
      password: newPassword.value,
      must_change_password: 0
    });

    // Update local storage
    user.must_change_password = false;
    localStorage.setItem('user', JSON.stringify(user));

    toast.success("Password updated successfully!");

    // Redirect to dashboard
    router.push('/hrdashboard');   

  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update password");
  } finally {
    isLoading.value = false;
  }
};
</script>